import React from 'react';
import Contatti from './Contatti';
import ComposizioneMail from './ComposizioneMail';
import { useNavigate } from 'react-router-dom';

function Comunicati() {
  const navigate = useNavigate();
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [placeholders, setPlaceholders] = React.useState([]);
  const [destinatariCount, setDestinatariCount] = React.useState(0);
  const [emailCount, setEmailCount] = React.useState(0);
  const [contactsKey, setContactsKey] = React.useState(0);

  const handleSendComplete = () => {
    setSelectedRows([]);
    setDestinatariCount(0);
    setEmailCount(0);
    setContactsKey(k => k + 1);
  };

  // 🔧 COMPOSIZIONE MAIL SEMPRE VISIBILE
  const showComposizioneMail = true;

  return (
    <div className="container mt-4">
      <div className="row">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h1 className="text-info">
                <i className="fas fa-bullhorn"></i> Gestione Comunicati
              </h1>
              <p className="text-muted">Invia comunicati ufficiali agli enti e ai referenti ANUTEL ETS</p>
            </div>
            <div>
              <button className="btn btn-outline-info" onClick={() => navigate('/dashboard')}>
                <i className="fas fa-arrow-left"></i> Torna al Dashboard
              </button>
            </div>
          </div>
        </div>
      </div>

      <Contatti
        key={contactsKey}
        destinatariId={31}
        onSelectionChange={({ selectedRows, destinatariCount, emailCount, placeholders }) => {
          console.log('Comunicati - onSelectionChange ricevuto:', { selectedRows, destinatariCount, emailCount, placeholders });
          setSelectedRows(selectedRows || []);
          setDestinatariCount(destinatariCount || 0);
          setEmailCount(emailCount || 0);
          setPlaceholders(placeholders || []);
        }}
      />

      {showComposizioneMail && (
        <ComposizioneMail
          servizio="Comunicati"
          destinatariCount={destinatariCount}
          emailCount={emailCount}
          placeholders={placeholders.length > 0 ? placeholders : ['{RAGIONESOCIALE}', '{TIPOENTE}', '{COMUNE}', '{SIGLAPROV}', '{REGIONE}', '{SOCIO}']}
          selectedRows={selectedRows}
          onSendComplete={handleSendComplete}
        />
      )}
    </div>
  );
}

export default Comunicati;
